import{useContext}from"react";import{UseUrlManagerContext}from"../../contexts/use-url-manager.context.js";function useUrlManagerContext(){return useContext(UseUrlManagerContext)()}export{useUrlManagerContext};
